import { useField } from "formik";

import {
  ColorPicker,
  ColorPickerProps,
} from "../components/inputs/color-picker/ColorPicker";

interface Props extends ColorPickerProps {
  name: string;
}

export function ColorPickerFormikField(props: Props) {
  const {
    name,
    testID,
    label,
    info,
    isRequired,
    isDisabled,
    onChange,
    onDone,
    ...rest
  } = props;
  const [field, meta, helpers] = useField<string | null>(name);

  return (
    <ColorPicker
      {...rest}
      value={field.value || ""}
      testID={testID}
      label={label}
      info={info}
      isRequired={isRequired}
      isDisabled={isDisabled}
      errors={meta.touched ? meta.error : undefined}
      onChange={(value) => {
        const hex = (value as any)?.toString?.("hex") ?? String(value ?? "");
        helpers.setValue(hex);
        onChange?.(value);
      }}
      onDone={(color) => {
        helpers.setValue(color);
        onDone?.(color);
      }}
    />
  );
}
